enum TabsViews {
	OVERVIEW = 'Overview',
	COMPONENTS = 'Components',
	PAGES = 'Pages',
	ISSUE_TYPES = 'Issue types',
	BREAKDOWN = 'All issues'
}

export { TabsViews };
